<template>
  <QuestionWrapper
    v-if="pcpsOnFile.length === 1"
    :modelValue="modelValue"
    :title="$t('health_actions.scheduling.personal_doctor_title')"
    :options="options"
    @update:modelValue="$emit('update:modelValue', $event)"
  >
    <template #default>
      <DoctorCard :doctor="pcpsOnFile[0]" />
    </template>
  </QuestionWrapper>
  <div v-else class="flex flex-col gap-24">
    <TypographyH1 class="font-semibold">
      {{ $t('health_actions.scheduling.personal_doctor_title_multiple') }}
    </TypographyH1>
    <DoctorCardSelect
      v-for="doctor in pcpsOnFile"
      :key="doctor.id"
      :doctor="doctor"
      :canSelectMultiple="false"
      @user-did-select-doctor="$emit('update:modelValue', $event)"
    />
    <div class="flex flex-row w-full flex-1 items-center">
      <div class="h-1 border-t border-grey-300 flex-1" />
      <TypographyBody class="text-grey-500 font-semibold mx-16">
        {{ $t('common.or').toUpperCase() }}
      </TypographyBody>
      <div class="h-1 border-t border-grey-300 flex-1" />
    </div>
    <div>
      <div
        v-if="isMobileScreenSize"
        :class="[
          'flex flex-row items-center rounded-md justify-between m-4 h-200 box-border w-full',
          modelValue === 'choose-another-doctor'
            ? 'border-blue-500 border-2 p-23'
            : 'border p-24',
        ]"
      >
        <div class="h-full flex flex-shrink flex-row items-center my-4">
          <input
            id="choose-another-doctor"
            :checked="modelValue === 'choose-another-doctor'"
            value="choose-another-doctor"
            class="p-8"
            type="radio"
            @change="
              () => {
                resetDoctor()
                $emit('update:modelValue', 'choose-another-doctor')
              }
            "
          />
          <label for="choose-another-doctor" class="ml-4">Select</label>
        </div>
      </div>
      <!-- Desktop / Tablet view -->
      <div
        v-else
        :class="[
          'flex flex-row items-center rounded-md justify-between m-4 h-125 py-20 box-border w-full',
          modelValue === 'choose-another-doctor'
            ? 'border-blue-500 border-4 px-17'
            : 'border px-20',
        ]"
      >
        <div class="flex flex-row items-center h-full w-full">
          <div class="h-full flex flex-shrink flex-row items-center ml-8">
            <label for="choose-another-doctor" class="mr-24">
              <input
                id="choose-another-doctor"
                :checked="modelValue === 'choose-another-doctor'"
                value="choose-another-doctor"
                class="p-8"
                type="radio"
                @change="
                  () => {
                    resetDoctor()
                    $emit('update:modelValue', 'choose-another-doctor')
                  }
                "
              />
            </label>
          </div>
          <div class="flex flex-col">
            <TypographyBody class="font-semibold">
              {{ $t('health_actions.scheduling.choose_a_new_doctor') }}
            </TypographyBody>
            <TypographyBody>
              {{ $t('health_actions.scheduling.choose_a_new_doctor_subtitle') }}
            </TypographyBody>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TypographyH1 from '~/components/common/Typography/H1.vue'
import QuestionWrapper from './QuestionWrapper.vue'
import DoctorCardSelect from './DoctorCard/DoctorCardSelect.vue'
import { mapGetters, mapActions } from 'vuex'
import TypographyBody from '~/components/common/Typography/Body.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import DoctorCard from './DoctorCard/DoctorCard.vue'

export default {
  components: {
    TypographyH1,
    TypographyBody,
    QuestionWrapper,
    DoctorCardSelect,
    DoctorCard,
  },
  mixins: [screenSizeMixin],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isSelected: false,
    }
  },
  computed: {
    ...mapGetters('scheduling', ['pcpsOnFile']),
  },
  methods: {
    ...mapActions('scheduling', ['resetDoctor']),
  },
}
</script>
